import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {konverterIso8601DatoStrengTilDate} from "felles/infrastruktur/Iso8601DatostrengTilDate";

/*
 * Metoder for å migrere mellom modeller som er Ajs/Ng2 spesifikke.
 * Som hovedregel ligger forskjellene i at Ajs benytter Date men Ng2 benytter temporal
 */

export function kopierFraAjsTilNg2<NG2_TYPE = any>(kilde: any): NG2_TYPE {
    if (erNil(kilde)) return kilde as NG2_TYPE;
    return JSON.parse(JSON.stringify(kilde));
}

export function kopierFraNg2TilAjs<AJS_TYPE = any>(kilde: any): AJS_TYPE {
    if (erNil(kilde)) return kilde as AJS_TYPE;
    const kopi = JSON.parse(JSON.stringify(kilde));
    konverterIso8601DatoStrengTilDate(kopi);
    return kopi;
}
